module.exports = __webpack_public_path__ + "static/media/calculator.14672bda.svg";